<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="d-flex flex-column">
                <b-row class="sa-label-info">
                    <b-col lg="3">
                        <p>Record Totali: {{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="1" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="riga">
                            {{ riga.index + 1 }}
                        </template>
                        <template #cell(tipo)="item">
                            <span> {{ item.item.tipo }}</span>
                        </template>
                        <template #cell(codiceFlusso)="item">
                            <span> {{ item.item.codiceFlusso }}</span>
                        </template>
                        <template v-slot:cell(eventi)="{ item }">
                            <b-container class="bv-example-row">
                                <!-- <b-button size="sm" v-b-tooltip.hover title="Visualizza Impegnativa" variant="outline-secondary" @click="onClickView(item)">
                                    <font-awesome-icon icon="eye"> </font-awesome-icon>
                                </b-button> -->
                                <!-- class="mr-1 no-text" -->
                                <b-button size="sm" v-b-tooltip.hover title="Modifica Impegnativa" variant="outline-success" @click="onClickEdit(item)">
                                    <font-awesome-icon icon="edit"> </font-awesome-icon>
                                </b-button>

                                <b-button size="sm" v-b-tooltip.hover title="Cancella Impegnativa" variant="outline-danger" @click="onClickDelete(item)">
                                    <font-awesome-icon icon="trash"></font-awesome-icon>
                                </b-button>
                            </b-container>
                        </template>
                    </b-table>
                </div>
                <rsa-configurazione-tipo-impegnativa-modal-edit-component ref="cmpRsaConfigurazioneTipoImpegnativaModalEditComponent" @onSave="onSaveImpegnativa" @onClose="loadData" @deleteImpegnativa="loadData"></rsa-configurazione-tipo-impegnativa-modal-edit-component>
            </div>
            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import RsaConfigurazioneTipoImpegnativaModalEditComponent from "./RsaConfigurazioneTipoImpegnativaModalEditComponent.vue";

export default {
    components: {
        RsaConfigurazioneTipoImpegnativaModalEditComponent,
    },
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResource: "/rsaimpegnativatipo",
            showModalLoading: false,
            listKey: 0,
            items: [],
            filtroImpegnativa: { tipo: null, codiceFlusso: null },
            btnNuovaPrestazioneHidden: false,
            fields: [
                {
                    label: "",
                    key: "index",
                    sortable: false,
                },
                {
                    label: "Tipo",
                    key: "tipo",
                    sortable: false,
                },
                {
                    label: "Cod. Flusso",
                    key: "codiceFlusso",
                    sortable: false,
                },
                {
                    class: "sa-table-column-action-double",
                    key: "eventi",
                    label: "",
                },
            ],
        };
    },
    mounted() {
        let me = this;
        me.id = this.$route.params.id;
        me.loadData();
    },
    watch: {
        currentPage() {
            let me = this;
            me.loadData();
        },
    },
    methods: {
        loadData() {
            let me = this;
            me.$emit("beforeLoadData");
            let sessionStorage = window.sessionStorage;
            if (sessionStorage["filtroImpegnativa"]) {
                me.filtroImpegnativa = JSON.parse(sessionStorage["filtroImpegnativa"]);
                me.$emit("updateFilter", me.filtroImpegnativa);
            }
            me.filtroImpegnativa.page = me.currentPage;
            me.filtroImpegnativa.forPage = me.perPage;
            UtilityMixin.methods.loadDataResources(me.pathResource, me.filtroImpegnativa, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.data.recordsNumber;
            me.$emit("afterLoadData");
        },
        loadDataError(error) {
            let me = this;
            console.error("Errore durante il caricamento dei dati:", error);
            me.items = [];
            me.rows = 0;
            me.$emit("afterLoadData");
        },
        /* onClickView(items) {
        }, */
        onClickEdit(item) {
            let me = this;
            me.$refs.cmpRsaConfigurazioneTipoImpegnativaModalEditComponent.show(item);
        },
        onClickNuovoTipoImpegnativa() {
            let me = this;
            me.$refs.cmpRsaConfigurazioneTipoImpegnativaModalEditComponent.show({
                id: null,
                tipo: null,
                codiceFlusso: null,
            });
        },
        onClickDelete(item) {
            let me = this;
            me.$refs.cmpRsaConfigurazioneTipoImpegnativaModalEditComponent.onDeleteImpegnativa(item);
        },
        onSaveImpegnativa() {
            let me = this;
            me.loadData();
        },
    },
};
</script>
